import { useAuth } from './useAuth'
import { useConfig } from '../Components/Config/ConfigContext'
import { useCallback } from 'react'

export const useApi = () => {
  const { accessToken } = useAuth()
  const config = useConfig()

  const fetchApi = useCallback(
    async (options: { endpoint: string; method: string; body?: any; signal?: AbortSignal }) => {
      const { endpoint, method, body, signal } = options

      if (!config || !config.host) {
        throw new Error('API base URL is missing in the configuration.')
      }
      if (!accessToken) {
        return
      }

      const requestBody =
        method.toUpperCase() === 'GET' || method.toUpperCase() === 'HEAD' ? undefined : body ? JSON.stringify(body) : undefined

      const response = await fetch(`${config.host}${endpoint}`, {
        method,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: requestBody,
        signal
      })

      if (!response.ok) {
        const errorText = await response.text()
        const error: any = new Error(`API call failed with status ${response.status}`)

        try {
          error.data = JSON.parse(errorText)
        } catch (e) {
          error.data = errorText
        }

        error.status = response.status
        error.response = { data: error.data, status: response.status }

        throw error
      }

      const contentType = response.headers.get('Content-Type')
      const text = await response.text()

      if (contentType && contentType.includes('application/json')) {
        try {
          return JSON.parse(text)
        } catch (e) {
          console.error('JSON parse failed', e)
          return null
        }
      } else {
        return text || null
      }
    },
    [accessToken, config]
  )

  return { fetchApi }
}
